"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcButtonGroupBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var default_behavior_1 = require("../../../common/models/default-behavior");
var button_group_constants_1 = require("./button-group-constants");
var BcButtonGroupBehavior = (function (_super) {
    __extends(BcButtonGroupBehavior, _super);
    function BcButtonGroupBehavior() {
        var _this = _super.call(this) || this;
        _this.buttonsState = [];
        return _this;
    }
    BcButtonGroupBehavior.setUpAll = function () {
        var containers = Array.from(document.querySelectorAll("".concat(common_constants_1.BcCommonConstants.ARTICLE_TAG, ".").concat(button_group_constants_1.BC_BUTTON_GROUP.CONTAINER)));
        var bcButtonGroupBehavior = new BcButtonGroupBehavior();
        var elements = [];
        for (var _i = 0, containers_1 = containers; _i < containers_1.length; _i++) {
            var element = containers_1[_i];
            bcButtonGroupBehavior.setElement(element);
            bcButtonGroupBehavior.setUp();
            elements.push(bcButtonGroupBehavior);
        }
        return elements;
    };
    BcButtonGroupBehavior.prototype._setUp = function () {
        this.setElements();
        this.selectElements();
        try {
            if (this.inputElements.length < common_constants_1.COMMON_CONSTANTS_NUMBERS.N2 ||
                this.inputElements.length > common_constants_1.COMMON_CONSTANTS_NUMBERS.N4) {
                this.mySelf.innerHTML = '';
                throw Error(" Debe haber al menos 2 y como m\u00E1ximo 4 botones. Actualmente tiene: ".concat(this.inputElements.length));
            }
            else {
                this.setUpAllFeatures();
            }
        }
        catch (error) {
            this.mySelf.innerHTML = error;
        }
    };
    BcButtonGroupBehavior.prototype.selectElements = function () {
        for (var _i = 0, _a = this.inputElements; _i < _a.length; _i++) {
            var element = _a[_i];
            (0, helpers_1.addFocusable)(element);
        }
    };
    BcButtonGroupBehavior.prototype.setUpAllFeatures = function () {
        this.setCheckedProperty();
        this.setIndicatorFeatures();
        this.setLabelWidth();
        this.setEventListeners();
        this.setIndicatorColor();
        this.addFontSizeClass();
    };
    BcButtonGroupBehavior.prototype.setElements = function () {
        var checked = "".concat(common_constants_1.BcCommonConstants.INPUT_TAG, ".").concat(button_group_constants_1.BC_BUTTON_GROUP.INPUT, ":").concat(common_constants_1.BcCommonConstants.CHECKED, " + ").concat(common_constants_1.BcCommonConstants.LABEL_TAG);
        this.container = this.mySelf;
        this.indicator = this.mySelf.querySelector("".concat(common_constants_1.BcCommonConstants.DIV_TAG, ".").concat(button_group_constants_1.BC_BUTTON_GROUP.INDICATOR));
        this.labels = Array.from(this.mySelf.querySelectorAll("".concat(common_constants_1.BcCommonConstants.INPUT_TAG, ".").concat(button_group_constants_1.BC_BUTTON_GROUP.INPUT, "+ ").concat(common_constants_1.BcCommonConstants.LABEL_TAG)));
        this.inputElements = Array.from(this.mySelf.querySelectorAll("".concat(common_constants_1.BcCommonConstants.INPUT_TAG, ".").concat(button_group_constants_1.BC_BUTTON_GROUP.INPUT)));
        this.checkedLabel = this.mySelf.querySelector(checked);
    };
    BcButtonGroupBehavior.prototype.setIndicatorFeatures = function () {
        this.setCheckedInput();
        this.setIndicatorPosition();
        this.setIndicatorDimensions();
        this.setAriaCheckedInput();
    };
    BcButtonGroupBehavior.prototype.setCheckedProperty = function () {
        var _this = this;
        var isChecked = common_constants_1.COMMON_CONSTANTS_NUMBERS.N0;
        this.inputElements.forEach(function (button, index) {
            if (button.getAttribute(button_group_constants_1.BC_BUTTON_GROUP.CHECKED_BUTTON_GROUP) === 'true') {
                isChecked++;
                _this.inputElements[index].setAttribute(common_constants_1.BcCommonConstants.CHECKED, '');
                _this.inputElements[index].setAttribute(common_constants_1.BcCommonConstants.ARIA_CHECKED, common_constants_1.BcCommonConstants.TRUE.toString());
            }
        });
        if (!isChecked) {
            this.inputElements[common_constants_1.COMMON_CONSTANTS_NUMBERS.N0].setAttribute(common_constants_1.BcCommonConstants.CHECKED, '');
            this.inputElements[common_constants_1.COMMON_CONSTANTS_NUMBERS.N0].setAttribute(common_constants_1.BcCommonConstants.ARIA_CHECKED, common_constants_1.BcCommonConstants.TRUE.toString());
        }
    };
    BcButtonGroupBehavior.prototype.setLabelWidth = function () {
        var width = Math.max(this.container.clientWidth) / this.labels.length;
        this.labels.forEach(function (label) {
            label.style.width = width + 'px';
        });
    };
    BcButtonGroupBehavior.prototype.setIndicatorDimensions = function () {
        this.indicator.style.width = Math.max(this.container.clientWidth) / this.labels.length + 'px';
    };
    BcButtonGroupBehavior.prototype.setIndicatorPosition = function () {
        this.indicator.style.left = this.getCheckedLabelAbsolutePosition().left;
        this.indicator.style.top = this.getCheckedLabelAbsolutePosition().top;
    };
    BcButtonGroupBehavior.prototype.getCheckedLabelAbsolutePosition = function () {
        var containLeft = this.container.getBoundingClientRect().left;
        var containPaddLeft = parseInt(getComputedStyle(this.container).paddingLeft);
        var containTop = this.container.getBoundingClientRect().top;
        var containPaddTop = parseInt(getComputedStyle(this.container).paddingTop);
        return {
            left: this.checkedLabel.getBoundingClientRect().left - containLeft - containPaddLeft + 'px',
            top: this.checkedLabel.getBoundingClientRect().top - containTop - containPaddTop + 'px',
        };
    };
    BcButtonGroupBehavior.prototype.setEventListeners = function () {
        var _this = this;
        this.inputElements.forEach(function (radioButton) {
            radioButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (_event) {
                if (_event.screenX && _event.screenY) {
                    _this.setIndicatorFeatures();
                }
            });
            radioButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (_event) {
                if (_event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER || _event.code === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE) {
                    _this.setIndicatorFeatures();
                }
            });
        });
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_RESIZE, function () {
            setTimeout(function () {
                _this.setIndicatorPosition();
                _this.setLabelWidth();
                _this.setIndicatorDimensions();
                _this.getCheckedLabelAbsolutePosition();
            }, button_group_constants_1.BC_BUTTON_GROUP.INIT_TIMEOUT);
        });
    };
    BcButtonGroupBehavior.prototype.setCheckedInput = function () {
        var checked = "".concat(common_constants_1.BcCommonConstants.INPUT_TAG, ".").concat(button_group_constants_1.BC_BUTTON_GROUP.INPUT, ":").concat(common_constants_1.BcCommonConstants.CHECKED, " + ").concat(common_constants_1.BcCommonConstants.LABEL_TAG);
        this.checkedLabel = this.mySelf.querySelector(checked);
        if (this.checkedLabel && this.indicator) {
            var spanElement = this.indicator.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
            if (spanElement) {
                spanElement.textContent = this.checkedLabel.textContent;
            }
        }
    };
    BcButtonGroupBehavior.prototype.addFontSizeClass = function () {
        var labelSize = this.fontSize === common_constants_1.BcCommonConstants.DEFAULT ? button_group_constants_1.BC_BUTTON_GROUP.DEFAULT : this.fontSize === common_constants_1.BcCommonConstants.SMALL ? button_group_constants_1.BC_BUTTON_GROUP.SMALL : button_group_constants_1.BC_BUTTON_GROUP.X_SMALL;
        this.indicator.classList.remove(button_group_constants_1.BC_BUTTON_GROUP.SMALL, button_group_constants_1.BC_BUTTON_GROUP.X_SMALL, button_group_constants_1.BC_BUTTON_GROUP.DEFAULT);
        this.indicator.classList.add(labelSize);
        this.labels.forEach(function (label) {
            label.className = labelSize;
        });
    };
    BcButtonGroupBehavior.prototype.addShadowClass = function () {
        var labelShadow = this.shadow === 'true' ? button_group_constants_1.BC_BUTTON_GROUP.SHADOW : button_group_constants_1.BC_BUTTON_GROUP.NO_SHADOW;
        this.container.classList.add(labelShadow);
    };
    BcButtonGroupBehavior.prototype.setIndicatorColor = function () {
        if (this.indicatorColor) {
            switch (this.indicatorColor) {
                case button_group_constants_1.BC_BUTTON_GROUP.BLACK_INDICATOR_INPUT:
                    this.indicator.className = button_group_constants_1.BC_BUTTON_GROUP.INDICATOR;
                    this.indicator.classList.add(button_group_constants_1.BC_BUTTON_GROUP.BLACK_INDICATOR_COLOR);
                    break;
                default:
                    this.indicator.className = button_group_constants_1.BC_BUTTON_GROUP.INDICATOR;
                    this.indicator.classList.add(button_group_constants_1.BC_BUTTON_GROUP.DEFAULT_INDICATOR_COLOR);
            }
        }
        else {
            this.indicator.classList.add(button_group_constants_1.BC_BUTTON_GROUP.DEFAULT_INDICATOR_COLOR);
        }
        this.addFontSizeClass();
        this.addShadowClass();
    };
    BcButtonGroupBehavior.prototype.setInitialIndicator = function () {
        var checked = "".concat(common_constants_1.BcCommonConstants.INPUT_TAG, ".").concat(button_group_constants_1.BC_BUTTON_GROUP.INPUT, ":").concat(common_constants_1.BcCommonConstants.CHECKED);
        var input = this.mySelf.querySelector(checked);
        var span = this.indicator.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
        span.textContent = input.value;
    };
    BcButtonGroupBehavior.prototype.setFontSize = function (fontSize) {
        this.fontSize = fontSize;
        this.addFontSizeClass();
    };
    BcButtonGroupBehavior.prototype.setShadow = function (shadow) {
        this.shadow = shadow;
        this.addShadowClass();
    };
    BcButtonGroupBehavior.prototype.setActiveButtonColor = function (indicatorColor) {
        this.indicatorColor = indicatorColor;
        this.setIndicatorColor();
    };
    BcButtonGroupBehavior.prototype.setAriaCheckedInput = function () {
        for (var _i = 0, _a = this.inputElements; _i < _a.length; _i++) {
            var inputElement = _a[_i];
            var radioButton = inputElement;
            if (radioButton.checked) {
                radioButton.setAttribute(common_constants_1.BcCommonConstants.ARIA_CHECKED, common_constants_1.BcCommonConstants.TRUE.toString());
            }
            else {
                radioButton.setAttribute(common_constants_1.BcCommonConstants.ARIA_CHECKED, common_constants_1.BcCommonConstants.FALSE.toString());
            }
        }
    };
    return BcButtonGroupBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcButtonGroupBehavior = BcButtonGroupBehavior;
